export default "__VITE_ASSET__DIOrQigc__"